import { SeatType } from '@vista-digital/ocapi-types/v1';
import { Validator } from '@vista-digital/validator';
export const seatPositionValidator = Validator.object({
    areaNumber: Validator.number({ min: 1 }),
    columnNumber: Validator.number({ min: 1 }),
    rowNumber: Validator.number({ min: 1 })
});
export const seatTypeValidator = Validator.oneOf(Object.values(SeatType));
export const seatValidator = Validator.object({
    id: Validator.nonEmptyString,
    areaCategoryId: Validator.nonEmptyString,
    position: seatPositionValidator,
    seatGroupIds: Validator.array({ items: Validator.nonEmptyString }),
    label: Validator.optional(Validator.nonEmptyString),
    rowLabel: Validator.nonEmptyString,
    type: seatTypeValidator
});
//# sourceMappingURL=validators.js.map